import dayjs from 'dayjs';
import { makeStyles } from '@material-ui/styles';
import { MDSChip, MDSTableCell, MDSTableRow, MDSTag, MDSTheme } from '@marqvision/mds/core';
import { MDSTypography } from '@marqvision/mds-v2';
import { ExtensionIcon } from '@marqvision/shared/src/common/ExtensionIcon';
import { ClientRequestProtocolGetCrListResponseCR } from '~/swagger/data-contracts';
import { sliceFilename } from '../../@utils';
import { requestTypeLabel, requestStatusColor, requestStatusLabel } from '../../@constants';
import { ListTableColgroup } from './ListTableColgroup';

const useStyles = makeStyles({
  wrapper: {
    padding: '0 !important',
    cursor: 'pointer',
    '&:hover $summeryBox':{
      backgroundColor: MDSTheme.palette.bluegray[150],
    },
  },
  innerTable: {
    '& tr td': {
      border: 'none',
    },
  },
  summeryBox: {
    padding: '8px 12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    borderRadius: '8px',
    backgroundColor: MDSTheme.palette.bluegray[50],
  },
  type: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  fileList: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
});

type Props = {
  onClick: () => void;
  data: ClientRequestProtocolGetCrListResponseCR;
};

export const ListTableRow = (props: Props) => {
  const { onClick, data } = props;
  const classes = useStyles();

  return (
    <MDSTableRow>
      <MDSTableCell colSpan={4} className={classes.wrapper} onClick={onClick}>
        <div>
          <table width="100%" className={classes.innerTable}>
            <ListTableColgroup />
            <tbody>
            <tr>
              <MDSTableCell>
                {data.clientCrId}
              </MDSTableCell>
              <MDSTableCell>
                {requestTypeLabel[data.crType]}
              </MDSTableCell>
              <MDSTableCell>
                <div className={classes.type}>
                  <MDSTag
                    variant="tint"
                    size="medium"
                    color={requestStatusColor[data.crStatus]}
                    label={requestStatusLabel[data.crStatus]}
                  />
                  {data.showNewBadge && (
                    <MDSTag variant="fill" color="red" size="x_small" label="N" />
                  )}
                </div>
              </MDSTableCell>
              <MDSTableCell>
                {dayjs(data.requestedDate).format('MMM D, YYYY')}
              </MDSTableCell>
            </tr>
            <tr>
              <MDSTableCell colSpan={4}>
                <div className={classes.summeryBox}>
                  <MDSTypography variant="T14" color="color/content/neutral/secondary/normal" lineClamp={1} wordBreak="break-all">
                    {data.details}
                  </MDSTypography>
                  {!!data.attachments.length && (
                    <div className={classes.fileList}>
                      <MDSChip
                        variant="outline"
                        color="bluegray"
                        size="small"
                        icon={<ExtensionIcon fileName={data.attachments[0].name} />}
                        label={sliceFilename(data.attachments[0].name)}
                      />
                      {data.attachments.length > 1 && (
                        <MDSChip variant="outline" color="bluegray" size="small" label={`+${data.attachments.length - 1}`} />
                      )}
                    </div>
                  )}
                </div>
              </MDSTableCell>
            </tr>
            </tbody>
          </table>
        </div>
      </MDSTableCell>
    </MDSTableRow>
  );
};